module.exports = __webpack_public_path__ + "img/ios-only.f8fd9228.svg";